<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-12 21:16 -->
<!-- Description:  -->
<template>
  <div>
    <h4>LISTA DE PERMISOS</h4>
    <router-link class="btn btn-primary mb-3" :to="{ name: 'admin.permission-create' }">
      Nuevo Permiso</router-link>

    <app-apirest-table
      :getList="AdminService.getPermissions"
      ref="elApirestTable"
      v-slot:default="slotProps"
      :params="filters"
      >
      <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Slug</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(l, i) in slotProps.list" :key="i">
          <td>{{ l.id }}</td>
          <td>{{ l.name }}</td>
          <td>{{ l.slug }}</td>
          <td>
            <router-link class="btn btn-sm btn-light" :to="{ name: 'admin.permission-edit', params: { id: l.id }}">
              Editar
            </router-link>
            <button class="btn btn-sm btn-danger" @click="deleteItem(l)">
              Eliminar 
            </button>
          </td>
        </tr>
      </tbody>
    </app-apirest-table>
  </div>
</template>
<script>
import AdminService from "../AdminService.js";

// script content
export default {
  name: "PermissionListView",
  components: {
    //
  },

  // directives

  props: {
    //
  },

  data: () => ({
    AdminService,
    filters: {},
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    async deleteItem(item) {
      if( window.confirm("Eliminar registro?") ) {
        await AdminService.deletePermission(item.id);
        this.$refs.elApirestTable.reload();
      }
    }
    //
    //
  }
};
</script>
<style scoped></style>

